import zh_CN from "../i18n/translations/zh-cn.json"
import zh_TW from "../i18n/translations/zh-tw.json"
import en_US from "../i18n/translations/en-us.json"
import de_DE from "../i18n/translations/de.json"
import fr_FR from "../i18n/translations/fr.json"
import ru_RU from "../i18n/translations/ru.json"
import pt_PT from "../i18n/translations/pt.json"
import es_ES from "../i18n/translations/es.json"

let i18n = en_US;
let navigatorLang = 'en';

export const setI18n = (nativeLanguage) => {
    let _nativeLanguage = nativeLanguage ? nativeLanguage.replace('_', '-') : '';
    if(_nativeLanguage === 'zh-CN'
        || _nativeLanguage === 'zh-Hans'
        || _nativeLanguage === 'zh-Hans-CN'
        || _nativeLanguage === 'zh-MY'
        || _nativeLanguage === 'zh-SG') {
        i18n = zh_CN;
        navigatorLang = 'zh_CN';
        return ;
    }
    if(_nativeLanguage === 'zh-HK'
        || _nativeLanguage === 'zh-MO'
        || _nativeLanguage === 'zh-TW'
        || _nativeLanguage === 'zh-Hant'
        || _nativeLanguage === 'zh-Hant-CN') { 
        i18n = zh_TW;
        navigatorLang = 'zh_TW';
        return ;
    }
    if (_nativeLanguage === 'de' || _nativeLanguage === 'de-DE' || _nativeLanguage === 'de-AT' || _nativeLanguage === 'de-CH') {
        i18n = de_DE;
        navigatorLang = 'de';
        return;
    }
    if (_nativeLanguage=== 'ru' || _nativeLanguage === 'ru-RU') {
        i18n = ru_RU;
        navigatorLang = 'ru';
        return;
    }
    if (_nativeLanguage=== 'it' || _nativeLanguage === 'it-IT') {
        // i18n = it_IT;
        return;
    }
    if (_nativeLanguage=== 'id' || _nativeLanguage === 'id-ID') {
        // i18n = id_ID;
        return;
    }
    if (_nativeLanguage=== 'pt' || _nativeLanguage === 'pt-PT' || _nativeLanguage === 'pt-BR') {
        i18n = pt_PT;
        navigatorLang = 'pt';
        return;
    }
    if (_nativeLanguage=== 'th' || _nativeLanguage === 'th-TH') {
        // i18n = th_TH;
        return;
    }
    if (_nativeLanguage=== 'fr' || _nativeLanguage === 'fr-FR' || _nativeLanguage === 'fr-CH' || _nativeLanguage === 'fr-LU'
        || _nativeLanguage === 'fr-BE' || _nativeLanguage === 'fr-CA') {
        i18n = fr_FR;
        navigatorLang = 'fr';
        return;
    }
    if (_nativeLanguage === 'es' || _nativeLanguage === 'es-ES' || _nativeLanguage === 'es-AR' || _nativeLanguage === 'es-BO'
        || _nativeLanguage === 'es-CL' || _nativeLanguage === 'es-CO' || _nativeLanguage === 'es-CR'
        || _nativeLanguage === 'es-DO' || _nativeLanguage === 'es-EC' || _nativeLanguage === 'es-SV'
        || _nativeLanguage === 'es-GT' || _nativeLanguage === 'es-HN' || _nativeLanguage === 'es-MX'
        || _nativeLanguage === 'es-NI' || _nativeLanguage === 'es-PA' || _nativeLanguage === 'es-PY'
        || _nativeLanguage === 'es-PE' || _nativeLanguage === 'es-PR' || _nativeLanguage === 'es-UY'
        || _nativeLanguage === 'es-VE') {
        i18n = es_ES;
        navigatorLang = 'es';
        return;
    }
    if (_nativeLanguage === 'ja' || _nativeLanguage === 'ja-JP') {
        // i18n = ja_JP;
        return;
    }
    if (_nativeLanguage === 'tr' || _nativeLanguage === 'tr-TR') {
        // i18n = tr_TR;
        return;
    }
    if (_nativeLanguage === 'ko' || _nativeLanguage === 'ko-KR') {
        // i18n = ko_KR;
        return;
    }
    if (_nativeLanguage === 'vi' || _nativeLanguage === 'vi-VN') {
        // i18n = vi_VN;
        return;
    }
    if (_nativeLanguage === 'nl' || _nativeLanguage.includes('nl-')) {
        // i18n = nl;
        return;
    }
    if (_nativeLanguage === 'pl' || _nativeLanguage.includes('pl-')) {
        // i18n = pl;
        return;
    }
    if (_nativeLanguage === 'no' || _nativeLanguage.includes('no-')) {
        // i18n = no;
        return;
    }
    if (_nativeLanguage === 'sv' || _nativeLanguage.includes('sv-')) {
        // i18n = sv;
        return;
    }
    i18n = en_US;
}
export const getNavigatorLang = ()=>{
    return navigatorLang;
}
export const getI18n = () => {
    return i18n;
}

export const getMessage = (id, defaultMessage) => {
    let m = i18n[id];
    return m || defaultMessage;
}
export const languageSubset = {
    "en": "English",
    "de":"Deutsch",     // 德语
    "fr":"Français",    // 法语
    "ru":"Русский",     // 俄罗斯语
    "pt":"Português",   // 葡萄牙语
    "es":"Español",     // 西班牙语
    "zh_CN": "简体中文",
    "zh_TW": "繁體中文",
  };

export const languageSubset_ = {
    "zh_CN": "中文(简体)",
    "zh-hk": "中文(中国香港特别行政区)",
    "en": "英语",
    "en-us": "英语(美国)",
    "en-gb": "英语(英国)",
    "zh-sg": "中文(新加坡)",
    "zh_TW": "中文(中国台湾)",
    "en-au": "英语(澳大利亚)",
    "en-bz": "英语(伯利兹)",
    "en-ca": "英语(加拿大)",
    "en-ie": "英语(爱尔兰)",
    "en-jm": "英语(牙买加)",
    "en-nz": "英语(新西兰)",
    "en-tt": "英语(特立尼达)",
    "en-za": "英语(南非)",
    "af": "南非荷兰语",
    "ar-ae": "阿拉伯语(阿拉伯联合酋长国)",
    "ar-bh": "阿拉伯语(巴林)",
    "ar-dz": "阿拉伯语(阿尔及利亚)",
    "ar-eg": "阿拉伯语(埃及)",
    "ar-iq": "阿拉伯语(伊拉克)",
    "ar-jo": "阿拉伯语(约旦)",
    "ar-kw": "阿拉伯语(科威特)",
    "ar-lb": "阿拉伯语(黎巴嫩)",
    "ar-ly": "阿拉伯语(利比亚)",
    "ar-ma": "阿拉伯语(摩洛哥)",
    "ar-om": "阿拉伯语(阿曼)",
    "ar-qa": "阿拉伯语(卡塔尔)",
    "ar-sa": "阿拉伯语(沙特阿拉伯)",
    "ar-sy": "阿拉伯语(叙利亚)",
    "ar-tn": "阿拉伯语(突尼斯)",
    "ar-ye": "阿拉伯语(也门)",
    "be": "贝劳语",
    "bg": "保加利亚语",
    "ca": "加泰罗尼亚语",
    "cs": "捷克语",
    "da": "丹麦语",
    "de": "德语(标准)",
    "de-at": "德语(奥地利)",
    "de-ch": "德语(瑞士)",
    "de-li": "德语(列支敦士登)",
    "de-lu": "德语(卢森堡)",
    "el": "希腊语",
    "es": "西班牙语",
    "es-ar": "西班牙语(阿根廷)",
    "es-bo": "西班牙语(玻利维亚)",
    "es-cl": "西班牙语(智利)",
    "es-co": "西班牙语(哥伦比亚)",
    "es-cr": "西班牙语(哥斯达黎加)",
    "es-do": "西班牙语(多米尼加共和国)",
    "es-ec": "西班牙语(厄瓜多尔)",
    "es-gt": "西班牙语(危地马拉)",
    "es-hn": "西班牙语(洪都拉斯)",
    "es-mx": "西班牙语(墨西哥)",
    "es-ni": "西班牙语(尼加拉瓜)",
    "es-pa": "西班牙语(巴拿马)",
    "es-pe": "西班牙语(秘鲁)",
    "es-pr": "西班牙语(波多黎各)",
    "es-py": "西班牙语(巴拉圭)",
    "es-sv": "西班牙语(萨尔瓦多)",
    "es-uy": "西班牙语(乌拉圭)",
    "es-ve": "西班牙语(委内瑞拉)",
    "et": "爱沙尼亚语",
    "eu": "巴斯克语",
    "fa": "波斯语",
    "fi": "芬兰语",
    "fo": "法罗语",
    "fr": "法语(标准)",
    "fr-be": "法语(比利时)",
    "fr-ca": "法语(加拿大)",
    "fr-ch": "法语(瑞士)",
    "fr-lu": "法语(卢森堡)",
    "gd": "盖尔语(苏格兰)",
    "gd-ie": "盖尔语(爱尔兰)",
    "he": "希伯来语",
    "hi": "北印度语",
    "hr": "克罗地亚语",
    "hu": "匈牙利语",
    "id": "印尼语",
    "in": "印度语",
    "is": "冰岛语",
    "it": "意大利语(标准)",
    "it-ch": "意大利语(瑞士)",
    "ja": "日语",
    "ji": "依地语",
    "ko": "朝鲜语(韩国)",
    "lt": "立陶宛语",
    "lv": "拉脱维亚语",
    "mk:FYRO": "马其顿语",
    "ms": "马来西亚语",
    "mt": "马耳他语",
    "nl": "荷兰语(标准)",
    "nl-be": "荷兰语(比利时)",
    "no": "挪威语",
    "pl": "波兰语",
    "pt": "葡萄牙语(葡萄牙)",
    "pt-br": "葡萄牙语(巴西)",
    "rm": "拉丁语系",
    "ro": "罗马尼亚语",
    "ro-mo": "罗马尼亚语(摩尔达维亚)",
    "ru": "俄语",
    "ru-mo": "俄语(摩尔达维亚)",
    "sb": "索布语",
    "sk": "斯洛伐克语",
    "sl": "斯洛文尼亚语",
    "sq": "阿尔巴尼亚语",
    "sr": "塞尔维亚语",
    "sv": "瑞典语",
    "sv-fi": "瑞典语(芬兰)",
    "sx": "苏图语",
    "sz": "萨摩斯语(拉普兰)",
    "th": "泰语",
    "tn": "瓦纳语",
    "tr": "土耳其语",
    "ts": "汤加语",
    "uk": "乌克兰语",
    "ur": "乌尔都语",
    "ve": "文达语",
    "vi": "越南语",
    "xh": "科萨语",
    "zu": "祖鲁语"
  };